import { useIdleTimeout } from "@/hooks/useIdleTimeout";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";

function formatTime(seconds: number): string {
  if (seconds > 60) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  }
  return `${seconds} second${seconds !== 1 ? "s" : ""}`;
}

export function SessionTimeoutWarning() {
  const { showWarning, remainingSeconds, stayActive, logout } = useIdleTimeout();

  return (
    <AlertDialog open={showWarning}>
      <AlertDialogContent onEscapeKeyDown={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <AlertDialogTitle>Session Expiring</AlertDialogTitle>
          <AlertDialogDescription>
            You will be logged out in{" "}
            <span className="font-semibold text-foreground">
              {formatTime(remainingSeconds)}
            </span>{" "}
            due to inactivity.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={logout}>Log Out</AlertDialogCancel>
          <AlertDialogAction onClick={stayActive}>
            Stay Logged In
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
